import React, { useEffect, useRef } from "react";

// IntersectionObserver-based reveal wrapper
export default function Reveal({ children, className = "", as: As = "div", delay = 0 }) {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => node.classList.add("is-visible"), delay);
            obs.unobserve(node);
          }
        });
      },
      { threshold: 0.12 }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, [delay]);

  return (
    <As ref={ref} className={`reveal ${className}`}>
      {children}
    </As>
  );
}
